import { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { NAV } from "@/constants/testIds";

export default function Nav() {
	const [scrolled, setScrolled] = useState(false);

	useEffect(() => {
		const onScroll = () => setScrolled(window.scrollY > 40);
		onScroll();
		window.addEventListener("scroll", onScroll, { passive: true });
		return () => window.removeEventListener("scroll", onScroll);
	}, []);

	const handleNav = (id) => (e) => {
		e.preventDefault();
		const el = document.getElementById(id);
		if (!el) return;
		if (typeof window !== "undefined" && window.__lenis) {
			window.__lenis.scrollTo(el, { offset: -20 });
		} else {
			el.scrollIntoView({ behavior: "smooth", block: "start" });
		}
	};

	return (
		<motion.nav
			data-testid={NAV.root}
			initial={{ y: -20, opacity: 0 }}
			animate={{ y: 0, opacity: 1 }}
			transition={{ duration: 1.0, ease: [0.22, 1, 0.36, 1], delay: 0.15 }}
			className="fixed top-0 left-0 right-0 z-50 pt-4 md:pt-5 transition-all duration-500"
			style={{
				background: "rgba(248,249,250,0.72)",
				backdropFilter: "blur(16px)",
								WebkitBackdropFilter: "blur(16px)",
				borderBottom: scrolled ? "1px solid rgba(26,26,26,0.07)" : "1px solid rgba(26,26,26,0.04)",
				paddingBottom: scrolled ? 12 : 0,
			}}
		>
			<div className="max-container flex items-center justify-between text-[var(--bone)]">
				<a
					href="#top"
					onClick={handleNav("top")}
					data-testid={NAV.logo}
					className="flex items-center gap-2.5 group"
				>
					<span className="font-display text-[19px] tracking-[-0.02em] font-semibold whitespace-nowrap">Natant <span className="wordmark-ai">AI</span> Labs<span className="text-[var(--accent-green)]">.</span></span>
				</a>

				<div
					className="hidden md:flex items-center gap-1 px-1 py-1 rounded-full"
					style={{
						background: "rgba(15,15,15,0.05)",
						border: "1px solid rgba(15,15,15,0.08)",
					}}
				>
						<a
							href="#problem"
							data-testid={NAV.linkThesis}
							onClick={handleNav("problem")}
							className="px-4 py-2 rounded-full text-[14px] font-medium text-[var(--bone)] hover:bg-[var(--obsidian)] transition-colors"
						>The problem</a>
						<a
							href="#stack"
							onClick={handleNav("stack")}
							className="px-4 py-2 rounded-full text-[14px] font-medium text-[var(--bone)] hover:bg-[var(--obsidian)] transition-colors"
						>Natant</a>
						<a
							href="#members"
							data-testid={NAV.linkCohort}
							onClick={handleNav("members")}
							className="px-4 py-2 rounded-full text-[14px] font-medium text-[var(--bone)] hover:bg-[var(--obsidian)] transition-colors"
						>Cohort 1</a>
						<a
							href="#whitepaper"
							data-testid={NAV.linkWhitepaper}
							onClick={handleNav("whitepaper")}
							className="px-4 py-2 rounded-full text-[14px] font-medium text-[var(--bone)] hover:bg-[var(--obsidian)] transition-colors"
						>Whitepaper 01</a>
</div>

				<a
					href="/apply"
					data-testid={NAV.applyButton}
					className="pill-btn pill-btn--solid"
					style={{
						padding: "11px 22px",
						fontSize: 13,
						background: "var(--accent-green)",
						borderColor: "var(--accent-green)",
						color: "var(--obsidian)",
					}}
				>
					Apply for Cohort 1
				</a>
			</div>
		</motion.nav>
	);
}
